// Cyrillic → Latin transliteration for building URL slugs. Covers Russian
// plus the extra Kyrgyz/Kazakh letters (ң/ө/ү/қ/ғ/һ) — listing titles arrive
// in whichever of those a seller typed them in.
const translitMap: Record<string, string> = {
  а: "a", б: "b", в: "v", г: "g", д: "d", е: "e", ё: "e", ж: "zh", з: "z",
  и: "i", й: "y", к: "k", л: "l", м: "m", н: "n", о: "o", п: "p", р: "r",
  с: "s", т: "t", у: "u", ф: "f", х: "h", ц: "ts", ч: "ch", ш: "sh",
  щ: "sch", ъ: "", ы: "y", ь: "", э: "e", ю: "yu", я: "ya",
  ң: "ng", ө: "o", ү: "u", қ: "q", ғ: "g", һ: "h",
};

/** Lowercase, transliterate, hyphenate — "2-комнатная квартира" → "2-komnatnaya-kvartira". */
export function slugify(text: string): string {
  let out = "";
  for (const ch of text.toLowerCase()) {
    out += translitMap[ch] ?? ch;
  }
  return out
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60)
    .replace(/-+$/, "");
}

/**
 * Canonical listing URL: `/property/<id>-<slug>` when a title is available
 * (every real listing has one), falling back to the bare `/listing/<id>`
 * only when it isn't (e.g. a stripped-down search-suggestion item). Both
 * forms resolve to the same page (see routes.tsx) — this is just what new
 * links should point to so the SEO-friendly form is what accumulates.
 */
export function listingPath(listing: {
  id?: number | string | null;
  title?: string | null;
}): string {
  const id = listing?.id;
  if (id === undefined || id === null || id === "") return "#";
  const slug = listing.title ? slugify(listing.title) : "";
  return slug ? `/property/${id}-${slug}` : `/listing/${id}`;
}
